// src/components/sections/HeroBanner.js
import React from 'react';
import { DotLottieReact } from '@lottiefiles/dotlottie-react';

const HeroBanner = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mt-[50px] px-4 h-auto md:h-screen">
      {/* Left Column */}
      <div className="flex items-center justify-center">
        <h1 className="ml-0 md:ml-[100px] text-white text-4xl sm:text-6xl md:text-6xl lg:text-7xl xl:text-8xl font-semibold text-left leading-[1.2]"
          data-aos="fade-right"
          data-aos-delay="0"
        >
          Grow your <br />
          <span className="text-stroke-2">business</span> with
          <span className="gradient-text"> Vivekasoftek</span>
        </h1>
      </div>
      {/* Right Column (Video) */}
      <div 
  className="flex items-center justify-center transition-transform duration-500 ease-in-out hover:scale-110 hover:rotate-3"
  data-aos="fade-left"
  data-aos-delay="0"
>
  <div className="w-[200px] h-[200px] md:w-[280px] md:h-[280px] lg:w-[400px] lg:h-[400px] xl:w-[450px] xl:h-[450px]">
    <DotLottieReact
      src="https://lottie.host/63fdc2df-f8cb-48a9-9554-23cc6d1320f0/2LjSOwuxH3.lottie"
      loop
      autoplay
      className="w-full h-full"
      data-aos="zoom-in"
    />
  </div>
</div>

    </div>
  );
};

export default HeroBanner;